import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CaretRightOutlinedSvg from "@ant-design/icons-svg/es/asn/CaretRightOutlined";
import AntdIcon from "../components/AntdIcon";
var CaretRightOutlined = function CaretRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CaretRightOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CaretRightOutlined.displayName = 'CaretRightOutlined';
}
export default /*#__PURE__*/React.forwardRef(CaretRightOutlined);